let head = document.getElementById("header-grid");
head.classList.add("head-padding-start");

document.addEventListener("scroll", () => {
    if (window.pageYOffset > 30) {
        let head = document.getElementById("header-grid");
        head.classList.remove("head-padding-start");
        head.classList.add("head-padding-scroll");
    }

    if (window.pageYOffset === 0) {
        let head = document.getElementById("header-grid");
        head.classList.remove("head-padding-scroll");
        head.classList.add("head-padding-start");
    }
});

let scopri = document.getElementById("scopri");

scopri.addEventListener("click", ()=>{
   window.scrollTo(0, 500);
});

const removeLocale = document.getElementById("removeLocale");
if(removeLocale != null){
    const removable = document.querySelector(".locale-selectors__container");
    removable.style.display = "none";
}